import { render, staticRenderFns } from "./jobDetails.vue?vue&type=template&id=d6627118&scoped=true&"
import script from "./jobDetails.vue?vue&type=script&lang=js&"
export * from "./jobDetails.vue?vue&type=script&lang=js&"
import style0 from "./jobDetails.vue?vue&type=style&index=0&id=d6627118&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d6627118",
  null
  
)

export default component.exports